/** @jsxImportSource @emotion/react */
import React from "react";
import { BadgeBase } from "./BadgeBase";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";
import { css } from "@emotion/react";
import { StatusIndicator } from "./StatusIndicator";

type Props = {
  statusColor: string;
  children: React.ReactNode;
  size?: "large" | "small";
};

const labelContentStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: center;
  min-width: max-content;
`;

export const StatusBadge = ({
  statusColor,
  children,
  size = "small",
}: Props) => {
  const textClassname =
    size === "small" ? "bodySubtextRegular" : "bodyTextRegular";

  return (
    <BadgeBase>
      <div css={labelContentStyle}>
        <StatusIndicator backgroundColor={statusColor} />
        <StyledText
          className={`${textClassname} mb-0`}
          color={colors.textPrimary}
        >
          {children}
        </StyledText>
      </div>
    </BadgeBase>
  );
};
